<template>
  <div class="ps-collapse">
    <div class="ps-collapse-header" @click="active = !active">
      <slot name="header" :active="active"/>
    </div>
    <transition :name="transition">
      <div v-if="active" class="ps-collapse-content">
        <slot name="content" :active="active"/>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "PsCollapse",
  props: {
    transition: {type: String, default: 'collapse-transition'}
  },
  data() {
    return {
      active: false,
    }
  }
}
</script>

<style>
.collapse-transition-enter-active, .collapse-transition-leave-active {
  transition: opacity .6s, max-height .4s;
  max-height: 100vh;
  overflow: hidden;
}

.collapse-transition-enter, .collapse-transition-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

</style>
